module.exports = __webpack_public_path__ + "static/media/brain.eb3c02ab.svg";